import { EscapeButtonProps } from "./types";

/**
 * Button in the top left corner used to escape the current view. Chuck this anywhere a user might get stuck
 */
const EscapeButton = (props: EscapeButtonProps) => {
	return null;
};
export default EscapeButton;
